import { useEffect, useState } from "react";

/** The value, once it has stopped changing for `delay` ms. A search box bound
 * straight to a query sent one request per keystroke; bound through this it
 * sends one when the typing pauses. */
export function useDebounced<T>(value: T, delay = 250): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), delay);
    return () => window.clearTimeout(timer);
  }, [value, delay]);
  return settled;
}
